// @ts-nocheck
/* eslint-disable array-callback-return */
import { getValue, getValueFromKey } from './product-schema'

const getQueryStringLinkValue = (data, query) => {
  const { linkType } = query

  return getValue(
    {
      valueFrom: `_source.links.${linkType}.destination_url`,
    },
    data,
  )
}

export const getLinkAndText = (linkArray, query, data) => {
  let foundLink

  if (linkArray && linkArray.length) {
    foundLink = linkArray.reduce((acc, cur) => {
      if (acc) return acc

      if (typeof cur.validIf === 'string' && !getValueFromKey(cur.validIf, data)) {
        return
      } else if (typeof cur.validIf !== 'string' && cur.validIf && !getValue(cur.validIf, data)) {
        return
      }

      if (typeof cur.validIfNot !== 'string' && cur.validIfNot && getValue(cur.validIfNot, data)) {
        return
      }

      if (cur.href.valueFromQueryString && query.linkType) {
        const link = getQueryStringLinkValue(data, query)
        if (link) {
          return {
            clickoutHrefFromSchema: link,
            ctaTextFromSchema: getValue(cur.text, data),
          }
        }
      }
      if (cur.href.valueFrom || cur.href.value) {
        const link = getValue(cur.href, data)
        if (link) {
          return {
            clickoutHrefFromSchema: link,
            ctaTextFromSchema: getValue(cur.text, data),
          }
        }
      }
    }, null)
  }

  if (foundLink) {
    return foundLink
  } else {
    return {
      clickoutHrefFromSchema: '',
      ctaTextFromSchema: '',
    }
  }
}

export const getLink = (linkArray, query, data) => {
  return linkArray.reduce((acc, cur) => {
    if (acc) return acc
    if (typeof cur.validIf === 'string' && !getValueFromKey(cur.validIf, data)) {
      return
    } else if (typeof cur.validIf !== 'string' && cur.validIf && !getValue(cur.validIf, data)) {
      return
    }

    if (cur.valueFromQueryString && query.linkType) {
      const link = getQueryStringLinkValue(data, query)
      if (link) {
        return link
      }
    }
    if (cur.valueFrom) {
      const link = getValue(cur, data)
      if (link) {
        return link
      }
    }
  }, null)
}
